<template>
  <div class="block">
    <div class="block-title">京东福利券</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="券管理" name="synchronous">
        <TbCouponSynchronous ref="synchronousRef" />
      </el-tab-pane>
      <el-tab-pane label="券使用情况" name="couponTaoBaoDetail">
<!--        <couponTaoBaoDetail ref="couponTaoBaoDetailRef" />-->
      </el-tab-pane>
    </el-tabs>
    <couponTaoBaoDetail v-if="activeName === 'couponTaoBaoDetail'" ref="couponTaoBaoDetailRef" />
  </div>
</template>
<script>
import TbCouponSynchronous from "./TbCouponSynchronous.vue";
import couponTaoBaoDetail from "./component/couponTaoBaoDetail.vue";
export default {
  components: {
    TbCouponSynchronous,
    couponTaoBaoDetail
  },
  data() {
    return {
      activeName: "synchronous",
      agentName: "",
    };
  },
  mounted() {

  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
      if(tab.name === 'synchronous'){
        this.$refs.synchronousRef.reset();
      }else if(tab.name === 'couponTaoBaoDetail'){
        // this.$refs.couponTaoBaoDetailRef.reset();
      }
      console.log(tab.name, event, "ee");
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponJd/index.vue